<script lang="ts"></script>

<script setup lang="ts">
/**
 * 🅲🅾🅼🅿🅾🅽🅴🅽🆃 [RolledStatus]
 * Свернутый статус обработки фотографий оператором
 */

// Hooks
import { computed } from "vue";

// Store
import { useTIWStore } from "@/stores/tiw/tiw.js";
import CheckIcon from "@/ui/icons/check.vue";
import ExternalIcon from "@/ui/icons/external.vue";
import GearIcon from "@/ui/icons/gear.vue";
// Icons
import TimeIcon from "@/ui/icons/time.vue";

// Types
import type { I_RolledStatus } from "./rolledStatus.types.js";

const props = defineProps<I_RolledStatus>();

const TIWStore = useTIWStore();

const styles = computed(() => {
    const styleRules: Record<string, string> = {};

    if (TIWStore.customStyles.font.family) {
        styleRules["--custom-font-family"] = TIWStore.customStyles.font.family;
    }

    if (TIWStore.customStyles.font.size) {
        styleRules["--custom-font-size"] = `${TIWStore.customStyles.font.size}px`;
    }

    if (TIWStore.customStyles.color.text) {
        styleRules["--custom-color-text"] = TIWStore.customStyles.color.text;
    }

    if (TIWStore.customStyles.color.main) {
        styleRules["--custom-color-main"] = TIWStore.customStyles.color.main;
    }

    return styleRules;
});
</script>

<template>
    <div data-component="rolledStatus" class="tiw tiw__rolledStatus" :style="styles">
        <div class="tiw__rolledStatus__icons">
            <TimeIcon v-if="props.status === 'WAITING'" />
            <GearIcon v-if="props.status === 'GRADING'" />
            <CheckIcon v-if="props.status === 'PROCESSED'" />
        </div>
        <div class="tiw__rolledStatus__status">
            {{ props.header }}
        </div>
        <ExternalIcon class="tiw__rolledStatus__rollUp" @click="TIWStore.rollUpWidget" />
        <div class="tiw__rolledStatus__loader" :style="{ width: `${props.percent}%` }" />
    </div>
</template>

<style lang="scss" src="./rolledStatus.scss"></style>
